import { WidgetStrategy } from 'widgets/WidgetRegistry';
import TradeOptimizer from './TradeOptimizer';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import React from 'react';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';

export const tradeOptimizerDescription: DropdownTooltipText = {
    body: <TradeOptimizerDescription />,
    previews: [],
};

export const tradeOptimizerWidgetStrategy: WidgetStrategy = {
    title: 'Trade Optimizer',
    supportedHosts: ['layout'],
    reactComponentType: TradeOptimizer,
    description: tradeOptimizerDescription,
    categories: [WidgetCategory.TOP],
    requiredAuthorities: ['indigo.enableIndigo2Support'],
    portfolioSelectionRequirements: PortfolioSelectionRequirements.None,
};

function TradeOptimizerDescription() {
    return (
        <>
            <div>Launches the Trade Optimizer Application</div>
        </>
    );
}
